import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment Payment on Payment {\n    id\n    gateway\n    token\n    creditCard {\n      brand\n      firstDigits\n      lastDigits\n      expMonth\n      expYear\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
export var paymentFragment = gql(_templateObject());